module.exports = "https://portperrypedals.ca/_res/img/scanner2.6b5d7b8.jpg";